import apiClient, { safeJson } from '@/api/client';
import {
    GetCoachMemberSessionOffsetsParams,
    GetCoachMemberSessionOffsetsResponse,
    PutCoachMemberSessionOffsetsParams,
} from './types';

/**
 * @method get
 * @brief 강사 × 회원 페어별 누적 회차 리스트 조회
 */
export const getCoachMemberSessionOffsets = async ({
    centerId,
    coachId,
    year,
    month,
}: GetCoachMemberSessionOffsetsParams) => {
    const res = await apiClient.get(
        `v1/coachMemberSessionOffsets/center/${centerId}/coach/${coachId}`,
        {
            searchParams: { year, month },
        },
    );

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as GetCoachMemberSessionOffsetsResponse | null,
    };
};

/**
 * @method put
 * @brief 강사 × 회원 페어별 누적 회차 일괄 저장 (서버에서 offset으로 환산)
 */
export const putCoachMemberSessionOffsets = async ({
    centerId,
    coachId,
    body,
}: PutCoachMemberSessionOffsetsParams) => {
    const res = await apiClient.put(
        `v1/coachMemberSessionOffsets/center/${centerId}/coach/${coachId}`,
        {
            json: body,
        },
    );

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as { success: boolean } | null,
    };
};
